import React from "react";
import {
  GraduationCap,
  Brain,
  CalendarCheck,
  IndianRupee,
  ArrowRight,
  CheckCircle2,
  Building2,
  Globe,
} from "lucide-react";
import { Link } from "react-router-dom";

function Pricing_counseling_page() {
  return (
    <div className="mt-4 flex flex-col items-center justify-center p-0">
      {/* Pricing Section */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-6xl">
        {/* Career Clarity Session */}
        <div className="rounded-3xl bg-white border border-slate-200 p-6 shadow-sm flex flex-col hover:shadow-md transition">
          <div className="flex items-center gap-2">
            <Brain className="h-5 w-5" />
            <h3 className="text-lg font-semibold">Career Clarity Session</h3>
          </div>
          <p className="mt-1 text-sm text-slate-600">Cut the noise and build a concrete career roadmap.</p>
          <div className="mt-4 flex items-end gap-2">
            <IndianRupee className="h-5 w-5" />
            <span className="text-3xl font-extrabold">3,500</span>
            <span className="text-sm text-slate-500">/ session + 18% GST</span>
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Objective roadmap creation</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Profile capability review</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Interactive 1:1 session</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Career pathway exploration</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Alignment with academic background</li>
          </ul>
          <Link to="/pricing/career-clarity" className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2 rounded-2xl bg-white border border-slate-200 text-slate-900 hover:bg-slate-50 w-full transition">Learn More<ArrowRight className="h-4 w-4" /></Link>
        </div>

        {/* Comprehensive Counselling Program */}
        <div className="rounded-3xl bg-white border border-slate-200 p-6 shadow-sm flex flex-col hover:shadow-md transition">
          <div className="flex items-center gap-2">
            <CalendarCheck className="h-5 w-5" />
            <h3 className="text-lg font-semibold">Comprehensive Counselling</h3>
          </div>
          <p className="mt-1 text-sm text-slate-600">Structured multi-session mentorship for students and parents.</p>
          <div className="mt-4 flex items-end gap-2">
            <div className=" flex items-end gap-2">
              <IndianRupee className="h-5 w-5" />
              <span className="text-3xl font-extrabold">25,000</span>
              <span className="text-sm text-slate-500">/ 6 sessions + 18% GST</span>
            </div>
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Multi-session pacing</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Parental alignment checks</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />End-to-end strategic planning</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />In-depth profile building</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Extracurricular & academic mapping</li>
          </ul>
          <Link to="/pricing/comprehensive-counselling" className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2 rounded-2xl bg-white border border-slate-200 text-slate-900 hover:bg-slate-50 w-full transition">Learn More<ArrowRight className="h-4 w-4" /></Link>
        </div>

        {/* Application & Admission Support */}
        <div className="rounded-3xl bg-white border-2 border-slate-900 p-6 shadow-md flex flex-col relative hover:shadow-lg transition">
          <div className="absolute -top-3 right-4 bg-slate-900 text-white text-xs px-3 py-1 rounded-full">End-to-End</div>
          <div className="flex items-center gap-2">
            <GraduationCap className="h-5 w-5" />
            <h3 className="text-lg font-semibold">Application & Admission</h3>
          </div>
          <p className="mt-1 text-sm text-slate-600">Execution support: Shortlisting, essays, and interviews.</p>
          <div className="mt-4 flex items-end gap-2">
            <div className=" flex items-end gap-2">
              <IndianRupee className="h-5 w-5" />
              <span className="text-3xl font-extrabold">48,500</span>
              <span className="text-sm text-slate-500">+ 18% GST</span>
            </div>
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Multi-country shortlists</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />SOP, LOR, and Essay reviews</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Interview preparation</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Form filling & execution guidance</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Offer tracking and evaluation</li>
          </ul>
          <Link to="/pricing/application-admission-support" className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2 rounded-2xl bg-slate-900 text-white hover:bg-slate-800 w-full transition">Learn More<ArrowRight className="h-4 w-4" /></Link>
        </div>

        {/* India Admission Guidance */}
        <div className="rounded-3xl bg-white border border-slate-200 p-6 shadow-sm flex flex-col hover:shadow-md transition">
          <div className="flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            <h3 className="text-lg font-semibold">India Admission Guidance</h3>
          </div>
          <p className="mt-1 text-sm text-slate-600">Focused local guidance up to 10 colleges per cycle.</p>
          <div className="mt-4 flex items-end gap-2">
            <IndianRupee className="h-5 w-5" />
            <span className="text-3xl font-extrabold">25,000</span>
            <span className="text-sm text-slate-500">+ 18% GST</span>
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Up to 10 colleges per cycle</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Entrance exam guidance</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Documentation support</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Safety & reach tier shortlisting</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Post-exam counselling & decisions</li>
          </ul>
          <Link to="/pricing/india-admission-guidance" className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2 rounded-2xl bg-white border border-slate-200 text-slate-900 hover:bg-slate-50 w-full transition">Learn More<ArrowRight className="h-4 w-4" /></Link>
        </div>

        {/* Country-Focused Admission Support */}
        <div className="rounded-3xl bg-white border border-slate-200 p-6 shadow-sm flex flex-col hover:shadow-md transition">
          <div className="flex items-center gap-2">
            <Globe className="h-5 w-5" />
            <h3 className="text-lg font-semibold">Country-Specific Support</h3>
          </div>
          <p className="mt-1 text-sm text-slate-600">Strict compliance for rule-heavy destinations (e.g., Italy, Germany).</p>
          <div className="mt-4 flex items-end gap-2">
            <div className=" flex items-end gap-2">
              <IndianRupee className="h-5 w-5" />
              <span className="text-3xl font-extrabold">Custom Pricing</span>
            </div>
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Destination-specific strategy</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Visa compliance guidance</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Pre-enrolment & APS support</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Country-focused compliance & rules</li>
            <li className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-emerald-600" />Financial readiness checks</li>
          </ul>
          <Link to="/pricing/country-focused-admission-support" className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2 rounded-2xl bg-white border border-slate-200 text-slate-900 hover:bg-slate-50 w-full transition">Learn More<ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </div>
  );
}

export default Pricing_counseling_page;

